import { EnvContribution, getLegacyBindingContext } from "@visactor/vrender-core";

import { loadMathPicker } from "../picker/math-module";

import { bindTaroCanvasModules } from "../canvas/contributions/taro/modules";

import { bindTaroWindowContribution } from "../window/contributions/taro-contribution";

import { TaroEnvContribution } from "./contributions/taro-contribution";

export function bindTaroEnv(container) {
    var _a, _b;
    (null === (_b = (_a = container).isBound) || void 0 === _b ? void 0 : _b.call(_a, TaroEnvContribution)) || (container.bind(TaroEnvContribution).toSelf().inSingletonScope(), 
    container.bind(EnvContribution).toService(TaroEnvContribution));
}

export function loadTaroEnv(container = getLegacyBindingContext(), loadPicker = !0) {
    loadTaroEnv.__loaded || (loadTaroEnv.__loaded = !0, bindTaroEnv(container), bindTaroCanvasModules(container), 
    bindTaroWindowContribution(container), loadPicker && loadMathPicker(container));
}

loadTaroEnv.__loaded = !1;

export function initTaroEnv() {
    loadTaroEnv();
}
//# sourceMappingURL=taro.js.map